import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchFormService {

  saveLatestSearchParams(params: any) {
    localStorage.setItem('searchParams', params);
  }
}
